import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { AccountService } from '../../../services/account.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { environment } from '../../../../environments/environment';
import {
  MatCardContent,
  MatCardSubtitle,
  MatCardTitle,
  MatCardHeader,
  MatCard,
  MatCardActions,
} from '@angular/material/card';

@Component({
  selector: 'app-new-account-setup',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatSelectModule,
    MatLabel,
    MatPrefix,
    MatButton,
    RouterLink,
    MatCardContent,
    MatCardSubtitle,
    MatCardTitle,
    MatCardHeader,
    MatCard,
    MatCardActions,
  ],
  templateUrl: './new-account-setup.component.html',
  styleUrl: './new-account-setup.component.scss',
})
export class NewAccountSetupComponent implements OnInit {
  private fb = inject(FormBuilder);
  accountService = inject(AccountService);
  private router = inject(Router);
  private snackbar = inject(SnackbarService);
  private route = inject(ActivatedRoute);

  production = environment.production;
  height = 0;

  readonly countries = [
    { name: 'United States', dialCode: '1', code: 'US' },
    { name: 'Canada', dialCode: '1', code: 'CA' },
    { name: 'United Kingdom', dialCode: '44', code: 'GB' },
  ];

  loginForm = this.fb.group({
    email: [''],
    countryCode: ['US'],
    phoneNumber: [''],
  });

  get selectedCountryDialCode() {
    const countryCode = this.loginForm.get('countryCode')?.value;
    const country = this.countries.find((c) => c.code === countryCode);
    return country ? country.dialCode : '';
  }

  ngOnInit(): void {
    this.accountService.user$.subscribe((user) => {
      if (user) {
        this.route.queryParams.subscribe((params) => {
          const returnUrl = params['returnUrl'] || '/hours';
          this.router.navigate([returnUrl]);
        });
      }
    });
  }

  onSubmit(): void {
    const { email, phoneNumber, countryCode } = this.loginForm.value;
    const selectedCountry = this.countries.find((c) => c.code === countryCode);
    const dialCode = selectedCountry?.dialCode;
    const fullPhoneNumber = dialCode ? `+${dialCode}${phoneNumber}` : phoneNumber;
    this.accountService.getVerificationCodeForNewAccountSetup(email, fullPhoneNumber);
  }
}
